module.exports = __webpack_public_path__ + "static/media/close_circle.65855e9d.svg";